import React from 'react';
import { Icon } from '../icon/Icon.jsx';

/* The three-part treatment that makes paper-versus-live impossible to misread.
   This is a SAFETY DEVICE, not a decoration — no part of it is optional.
   1. viewport top edge  2. header pill  3. row / panel left border
   On-chain escalates to a fourth variant: a 4px repeating amber hatch and the
   pill LIVE · ON-CHAIN · IRREVERSIBLE. The hatch appears on the Wallet screen and
   on on-chain rows only, so it never becomes ambient. */

export function ModeEdge({ mode, style }) {
  if (!mode) return null;
  const onchain = mode === 'onchain';
  return (
    <div aria-hidden="true" style={{
      height: onchain ? 4 : 'var(--mode-edge-h)', width: '100%', flex: '0 0 auto',
      background: onchain ? 'var(--hatch-live)' : (mode === 'paper' ? 'var(--paper)' : 'var(--live)'),
      ...style,
    }} />
  );
}

export function ModePill({ mode, style }) {
  if (!mode) return null;
  const map = {
    live: { text: 'LIVE · REAL MONEY', colour: 'var(--live)', tint: 'var(--live-tint)', icon: 'circle', filled: true },
    paper: { text: 'PAPER · TESTNET', colour: 'var(--paper)', tint: 'var(--paper-tint)', icon: 'circle-dashed' },
    onchain: { text: 'LIVE · ON-CHAIN · IRREVERSIBLE', colour: 'var(--live)', tint: 'var(--live-tint)', icon: 'link-2' },
  }[mode];
  if (!map) return null;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 'var(--space-4)', padding: '2px 8px',
      background: map.tint, color: map.colour, border: '1px solid ' + map.colour,
      borderRadius: 'var(--radius-pill)', whiteSpace: 'nowrap',
      fontSize: 'var(--label-size)', lineHeight: 'var(--label-line)', fontWeight: 'var(--label-weight)',
      letterSpacing: 'var(--label-tracking)', ...style,
    }}>
      <Icon name={map.icon} size={11} filled={!!map.filled} />{map.text}
    </span>
  );
}

/* The third part: a panel or row left border. */
export function ModeBorder({ mode, children, style }) {
  const border = mode === 'live' ? '3px solid var(--live)'
    : mode === 'paper' ? '3px dashed var(--paper)' : '3px solid transparent';
  return <div style={{ borderLeft: border, ...style }}>{children}</div>;
}

/* The marker as one piece, for a screen frame that wants edge + pill together. */
export const ModeMarker = ({ mode, children, style }) => (
  <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, ...style }}>
    <ModeEdge mode={mode} />
    {children}
  </div>
);
